<template>
    <!-- <div class="my-jobs"> -->
        <!-- <div class="page-nav"> -->
            <nav class="jobs-nav" aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link class="breadcrumb-link" to="/myjobs/applied-jobs">Applied Jobs</router-link></li>
                <li class="breadcrumb-item"><router-link class="breadcrumb-link" to="/myjobs/saved-jobs">Saved Jobs</router-link></li>
            </ol>
            </nav>
        <!-- </div> -->
        <router-view></router-view>
    <!-- </div> -->
</template>
<script>
export default {
    
}
</script>
<style scoped>
    .page-nav{
        margin-top:0rem;
    }

    .breadcrumb{
        margin:0px!important;
    }

    .jobs-nav{
        background-color: var(--nav);
        height:4.5rem!important;
        padding-top:1.9rem!important;
        padding-left:0.9rem!important;
        border-bottom:1px solid var(--nav-border);
    }

     .breadcrumb-link{
            color:var(--navlink);
            text-decoration: none;
    }

    nav a.router-link-exact-active {
            color: var(--navlink-active);
    }

    @media(max-width: 768px) {
         .jobs-nav{
            height:4.0rem!important;
            padding-top:1.6rem!important;
        }

        .breadcrumb-link{
            font-size:0.9rem;
        }

         
    }
</style>